export const tree = {
  tabs: {
    glossary: {
      cfg: ({dconfig}) => dconfig.glossary?.on,
      datatype: [3, 24],
      parts: ['GlossaryManager'],
      tabGroup: 'overview',
      order: 997,
    },
  },
}
